var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.04 4.32L12.96 8.64 17.76 8.64 13.92 12.48 15.36 17.76 11.04 14.4 6.72 17.76 8.16 12.48 4.32 8.64 9.12 8.64z",
    transform: "translate(-61 -671) translate(47 657) translate(14 14) translate(.96 .96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 11.04c0 5.832-4.727 10.56-10.56 10.56S.48 16.872.48 11.04C.48 5.208 5.207.48 11.04.48S21.6 5.208 21.6 11.04z",
    transform: "translate(-61 -671) translate(47 657) translate(14 14) translate(.96 .96)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.674deb46.svg";
export { ForwardRef as ReactComponent };